import { render, staticRenderFns } from "./ReSearchObjBig.vue?vue&type=template&id=0884378d&scoped=true"
import script from "./ReSearchObjBig.vue?vue&type=script&lang=js"
export * from "./ReSearchObjBig.vue?vue&type=script&lang=js"
import style0 from "./ReSearchObjBig.vue?vue&type=style&index=0&id=0884378d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884378d",
  null
  
)

export default component.exports